<template>
  <div>
    <AddUser></AddUser>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AddUser = defineAsyncComponent(() =>
  import("@/components/addUser/AddUser")
);
export default {
  components: {
    AddUser,
  },
};
</script>
